<script>


/**
 * Index-1 component
 */
export default {
  components: {
  },
  methods: {
    /**
     * Toggle menu
     */
    toggleMenu() {
      document.getElementById("navbarCollapse").classList.toggle("show");
    }
  }
};
</script>
<template>
  <div>
    <!-- STRAT NAVBAR -->
    <nav class="navbar navbar-expand-lg fixed-top navbar-white navbar-custom sticky sticky-dark" id="navbar">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse"
        aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation" @click="toggleMenu()">
        <i class="mdi mdi-menu"></i>
      </button>
      <div class="container">
        <!-- LOGO -->
        <!--<a class="navbar-brand logo text-uppercase" href="/">-->
        <a class="navbar-brand logo text-uppercase">
          <img src="@/assets/images/d733e21027b40360fa0e214b8b25cae.jpg" alt="SCUM 大先生"
            style="width: 40px; height: auto;">
          SCUM 大先生
          <button type="button" onclick="alert('作者QQ:2569620067')" class="btn btn-custom navbar-btn btn-rounded">联系作者</button>
        </a>
        <div class="collapse navbar-collapse" id="navbarCollapse">
          <ul class="navbar-nav navbar-center" id="mySidenav">
            <li class="nav-item">
              <router-link to="/" class="nav-link">主页</router-link>
            </li>
            <li class="nav-item ">
              <router-link to="/index-1" class="nav-link ">管理工具</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/index-2" class="nav-link">网页日志</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/index-3" class="nav-link">前哨站</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/index-4" class="nav-link">软件实时日志</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/index-5" class="nav-link">群管</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/index-6" class="nav-link">内置商城</router-link>
            </li>
          </ul>
          <div class="nav-button ml-auto">
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>
<style scoped>
.music-control {
  position: absolute;
  top: 30px;
  right: 40px;
}

.music-control img {
  height: 30px;
  width: 30px;
  opacity: 0.8;
}

.row {
  display: flex;
  justify-content: center;
}

.home-small-title {
  display: inline-block;
  margin: 0 10px;
  position: relative;
  top: -135px;
}

::v-deep .modal-content {
  background-color: #000000;
  color: white;
  background: none;
  border: none;
}

::v-deep .modal-header {
  border: none;
}

/*.video-container {
    display: flex;
    justify-content: center; 
    align-items: center; 
    height: 200px; /* 设置容器的高度
  } */
.video-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
  /* 设置容器的高度*/
}

.video-container video {
  width: 50%;
  width: 800px;
  /*设置视频的宽度 */
  height: 400px;
  /* 设置视频的高度 */
}


::v-deep .modal-backdrop {
  opacity: 0.5;
}
</style>